import type { Requests } from "../common/request.common";
import type { FinanceReportResponseTypes } from "../common/response.common";
import { post } from "./common";

export const financeReport = {
    record(data: typeof Requests.FinanceReport.Record.Input) {
        return post<typeof data, FinanceReportResponseTypes.Record>(`/finance-report/record`, data);
    },
    generateExport(data: typeof Requests.FinanceReport.GenerateExport.Input) {
        return post<typeof data>(`/finance-report/generate-export`, data);
    },
};
